import { atom } from 'jotai';
import type { BlockNoteEditor } from '@blocknote/core';
import { atomWithStorage } from 'jotai/utils';
import {
  BID_DELIVERABLE_STATUSES,
  BID_DELIVERABLES_ORDER_FIELDS,
  BID_DELIVERABLES_VIEWS,
} from '@/features/bid-deliverables/constants';
import type { FilterMode, OrderDirection } from '@/filters';

export const deliverablesViewAtom = atomWithStorage<(typeof BID_DELIVERABLES_VIEWS)[number]>(
  'bid-deliverables-view',
  'list',
);

export const pendingDeliverableFilesAtom = atom<
  { deliverableId: string; file: File; replaces?: string }[]
>([]);

export const deliverablesFilterAtom = atomWithStorage<{
  status?: (typeof BID_DELIVERABLE_STATUSES)[number][];
  statusMode?: FilterMode;
  showNotRelevant?: boolean;
  order?: {
    direction?: OrderDirection;
    field?: (typeof BID_DELIVERABLES_ORDER_FIELDS)[number];
  };
}>('bid-deliverables-filter', {});

export const deliverableEditorAtom = atom<{
  docId: string;
  editor: BlockNoteEditor<any, any, any>;
} | null>(null);
export const activeDeliverableEditorAtom = atom(
  (get) => get(deliverableEditorAtom)?.editor ?? null,
);
